import { constants } from '../Localization';

export enum FormAction {
    ADD = 'add',
    EDIT = 'edit',
    DELETE = 'delete',
    COMPARE = 'compare',
}

export const modalActionButtonTextMap: Map<FormAction, string> = new Map<FormAction, string>([
    [FormAction.ADD, constants.FORM_PRIMARY_BUTTON_ADD],
    [FormAction.EDIT, constants.FORM_PRIMARY_BUTTON_SAVE],
    [FormAction.DELETE, constants.FORM_PRIMARY_BUTTON_DELETE],
    [FormAction.COMPARE, constants.FORM_PRIMARY_BUTTON_COMPARE],
]);
